import isEmpty from 'lodash/isEmpty';
import { WebPushPrimaryContent } from 'modules/campaigns/editor/types';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

import { useTemplateContext } from '../../../context';
import { LightText, StyledNewTabLink } from '../Sections.styled';

export const WebPushBehavior = () => {
  const {
    templateAndContent: { primaryContent },
  } = useTemplateContext();
  const { clickAction } = primaryContent as WebPushPrimaryContent;
  return (
    <CampaignFormField labelText="Click location">
      <ReadOnlyField name="clickLocation">
        {!isEmpty(clickAction) ? (
          <StyledNewTabLink href={clickAction as string}>{clickAction}</StyledNewTabLink>
        ) : (
          <LightText>Not set</LightText>
        )}
      </ReadOnlyField>
    </CampaignFormField>
  );
};
